module.exports = require("@zxing/browser");